import AddressIcon from '@mui/icons-material/Place';
import AddressList from './AddressList';

export default {
      list: AddressList,
      icon: AddressIcon,
}